__turbopack_context__.v({
  "list": "search-tool-tip-module-scss-module__OY7Ahq__list",
  "title": "search-tool-tip-module-scss-module__OY7Ahq__title",
  "trigger": "search-tool-tip-module-scss-module__OY7Ahq__trigger",
  "wrapper": "search-tool-tip-module-scss-module__OY7Ahq__wrapper",
});
